<h3>Material costings calculator</h3>
<div class="calculator-inner calc-col1">
    <div class="calc-fields">
        <div class="inline-label-fields">
            <label class="form-label">
                <span>Total SQM <input  type="number" placeholder="" class="form-control" [(ngModel)]="totalSqm" (ngModelChange)="materialCostChange($event)"><br>
                    Compacted depth of sub-base in mm <input [attr.disabled]="defaultMortar ? true : null"  type="number" placeholder="" class="form-control" [(ngModel)]="mortar" (ngModelChange)="materialCostChange($event)"> <br>
                    I dont't know (default at 50mm)<input type="checkbox" placeholder=""  value="1"  [(ngModel)]="defaultMortar" (ngModelChange)="materialCostChange($event)"></span>
            </label>
        </div>
        <!-- <p class="work-it-out-btn"><button type="button" class="btn-success">Work it Out</button></p> -->
        <div class="inline-label-fields"><label class="form-label"><span>Sand /Cement ratio <input [attr.disabled]="defaultRatio ? true : null" type="number"
                        placeholder="" class="form-control" [(ngModel)]="ratioFirst" (ngModelChange)="materialCostChange($event)"/><input [attr.disabled]="defaultRatio ? true : null"  type="number"
                        placeholder="" class="form-control ml-5"  [(ngModel)]="ratioSecond" (ngModelChange)="materialCostChange($event)" /><br>
                        I dont't know (default at 3/1) <input type="checkbox" placeholder="" class="ml-3" [(ngModel)]="defaultRatio" (ngModelChange)="materialCostChange($event)" >
                    </span></label>
        </div>
        <div class="mt-3">
            <h4>Total sand required</h4>
           <p > In 25KG Bags:<span> {{ this.J4 | number : '1.0-0' }}</span></p>
           <p> In Tonne bags:<span> {{ this.K13 | number : '1.0-0' }} </span></p>
           <p> Tone bag sand cost:<span> {{ this.totalSandPrice }}   </span></p>
           <h4>Total cement required</h4>
           <p> In 25KG Bags:<span>  {{ this.I4 | number : '1.0-0'}}</span></p>
           <p>Cement Price:<span>   {{ this.O4 | number:'1.2-2' }}</span></p>
          
        </div>
    </div>
</div>